export default "__VITE_ASSET__XyBq_Hbj__"